export default {
  SET_ERROR: 'SET_ERROR',
  RESET_ERROR: 'RESET_ERROR',
  SET_INFO: 'SET_INFO',
  RESET_INFO: 'RESET_INFO',
  SET_SUCCESS_MESSAGE: 'SET_SUCCESS_MESSAGE',
  RESET_SUCCESS_MESSAGE: 'RESET_SUCCESS_MESSAGE',
  SET_MITRA_DETAILS: 'SET_MITRA_DETAILS',
  IS_API_PROGRESS: 'IS_API_PROGRESS',
  SET_JOB_DESCRIPTION: 'SET_JOB_DESCRIPTION',
  SET_JOB_LISTINGS_CAROUSEL_CONTENT: 'SET_JOB_LISTINGS_CAROUSEL_CONTENT'
};
